'use client';

const CheckBox: React.FC<CheckBoxProps> = ({ children, checked, onClick }) => {
  return (
    <div className="flex items-start my-1">
      <input
        checked={checked}
        onChange={onClick}
        id="link-checkbox"
        data-testid="link-checkbox"
        type="checkbox"
        className="my-0.5 w-4"
      />
      <label htmlFor="link-checkbox" className="pl-2  text-sm text-on-grey-subtle ">
        {children}
      </label>
    </div>
  );
};

export default CheckBox;
